// removed by extract-text-webpack-plugin
module.exports = {"container":"App__container__1yQEW_1","inner":"App__inner__3BVKj_1","title":"App__title__382G7_1","loading":"App__loading__2wMPE_1"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"localIdentName":"[name]__[local]__[hash:base64:5]_1","importLoaders":true,"camelCase":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25017b74","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/App.vue
// module id = 17
// module chunks = 0